









































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Mutation, Action } from "vuex-class";
import { MutationMethod, ActionMethod } from "vuex";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import { Cluster } from "@/types/aznconnect_api";
import { Route } from "vue-router";

const DEFAULT_CLUSTER: string = "-";
const DEFAULT_DEPARTMENT: string = "-";
const DEFAULT_TYPE: string = "-";
const DEFAULT_PRIORITY: string = "-";

@Component({})
export default class MainToolbar extends Vue {
  @Prop({ default: DEFAULT_CLUSTER })
  cluster!: string;

  @Prop({ default: DEFAULT_DEPARTMENT })
  department!: string;

  @Prop({ default: DEFAULT_TYPE })
  type!: string;

  @Prop({ default: DEFAULT_PRIORITY })
  priority!: string;

  @Prop({ default: null })
  routeName!: string;

  @Getter("currentCluster", { namespace: "espoed" })
  getterCurrentCluster!: string;

  @Mutation("currentCluster", { namespace: "espoed" })
  storeCurrentCluster!: MutationMethod;

  @Getter("currentDepartment", { namespace: "espoed" })
  getterCurrentDepartment!: string;

  @Mutation("currentDepartment", { namespace: "espoed" })
  storeCurrentDepartment!: MutationMethod;

  @Getter("currentType", { namespace: "espoed" })
  getterCurrentType!: string;

  @Mutation("currentType", { namespace: "espoed" })
  storeCurrentType!: MutationMethod;

  @Getter("currentPriority", { namespace: "espoed" })
  getterCurrentPriority!: string;

  @Mutation("currentPriority", { namespace: "espoed" })
  storeCurrentPriority!: MutationMethod;

  @Getter("getClusters", { namespace: "espoed" })
  clusters!: Array<Cluster>;

  @Getter("getDepartments", { namespace: "espoed" })
  departments!: Array<Cluster>;

  @Getter("getTypes", { namespace: "espoed" })
  types!: Array<string>;

  @Getter("getPriorities", { namespace: "espoed" })
  priorities!: Array<string>;

  @Watch("cluster") onClusterChanged(val: string, oldVal: string) {
    this.storeCurrentCluster(val);
    this.loadDepartments(val);
  }

  @Watch("department") onDepartementChanged(val: string, oldVal: string) {
    this.storeCurrentDepartment(val);
  }

  @Watch("type") onTypeChanged(val: string, oldVal: string) {
    this.storeCurrentType(val);
  }

  @Watch("priority") onPriorityChanged(val: string, oldVal: string) {
    this.storeCurrentPriority(val);
  }

  @Action("loadTypes", { namespace: "espoed" })
  loadTypes!: ActionMethod;

  @Action("loadClusters", { namespace: "espoed" })
  loadClusters!: ActionMethod;

  @Action("loadDepartments", { namespace: "espoed" })
  loadDepartments!: ActionMethod;

  @Action("loadPriorities", { namespace: "espoed" })
  loadPriorities!: ActionMethod;

  get currentCluster(): string {
    return this.getterCurrentCluster;
  }

  set currentCluster(value: string) {
    this.navigate(
      this.routeName,
      value,
      DEFAULT_DEPARTMENT,
      this.currentType,
      this.priority,
    );
  }

  get currentDepartment(): string {
    return this.getterCurrentDepartment;
  }

  set currentDepartment(value: string) {
    this.navigate(
      this.routeName,
      this.currentCluster,
      value,
      this.currentType,
      this.priority,
    );
  }

  get currentType(): string {
    return this.getterCurrentType;
  }

  set currentType(value: string) {
    this.navigate(
      this.routeName,
      this.currentCluster,
      this.currentDepartment,
      value,
      this.priority,
    );
  }

  get currentPriority(): string {
    return this.getterCurrentPriority;
  }

  set currentPriority(value: string) {
    this.navigate(
      this.routeName,
      this.currentCluster,
      this.currentDepartment,
      this.currentType,
      value,
    );
  }

  get currentRouteName(): string {
    return this.routeName;
  }

  set currentRouteName(value: string) {
    this.navigate(value);
  }

  navigate(
    routeName: string,
    cluster?: string,
    department?: string,
    type?: string,
    priority?: string,
  ): void {
    this.$router.push({
      name: routeName,
      params: {
        cluster: cluster || this.currentCluster,
        department: department || this.currentDepartment,
        type: type || this.currentType,
        priority: priority || this.currentPriority,
      },
    });
  }

  mounted(): void {
    this.storeCurrentCluster(this.cluster);
    this.storeCurrentDepartment(this.department);
    this.storeCurrentType(this.type);
    this.storeCurrentPriority(this.priority);

    this.loadClusters();
    this.loadDepartments(this.currentCluster);
    this.loadTypes();
    this.loadPriorities();
  }
}
